/* ============
 * State of the auth module
 * ============
 *
 * The initial state of the auth module.
 */

export const keys = {
    NRC_INFO: "nrc_info",
    LOCATION: "location",
    OLD_CACHE_KEY: "old_cache_key"
};

const cache_version = null;

export const generate_key = (url = "", params = {}, state) => {
    let param_keys = Object.keys(params);

// Sort the keys
param_keys.sort();

// Map over the sorted keys to create the desired output
param_keys = param_keys.map(key => {
    return `${key}=${params[key]}`;
});
    let cacheKey = state ?
        state.config && state.config.key ? state.config.key : state.oldCacheKey :
        window.localStorage.getItem(keys.OLD_CACHE_KEY) ?
        window.localStorage.getItem(keys.OLD_CACHE_KEY) : null;

    if (cacheKey) {
        return `${url}${cacheKey}${$.makeArray(param_keys).join(",")}`;
    } else {
        return null;
    }
};

export default {
    config: {},
    oldCacheKey: window.localStorage.getItem(keys.OLD_CACHE_KEY) ?
        window.localStorage.getItem(keys.OLD_CACHE_KEY) : null,
    ttl: 1000 * 24 * 60 * 60 * 30,
    inPulling: {},
    promise: {},
    keys: keys,
    generate_key,
    [keys.ANNOUNCEMENT]: "",
    [keys.NRC_INFO]: window.localStorage.getItem(keys.NRC_INFO) ?
        window.localStorage.getItem(keys.NRC_INFO) : null,
    [keys.LOCATION]: {
        region: [],
        town: [],
        township: [],
        quarter: [],
        village: [],
    },
    routeHistory: [],
    labelStatus: [],
    labelData: [],
    locale: "mm",
};